import { IExtendedSearchData } from "src/api/server/extended-search";
import { ISelectedRanking } from "../components/types";

export const getDefaultRanking = (data: IExtendedSearchData): ISelectedRanking => {
    return {
        id: data.rankingsData.defaultSelectedRanking.id,
        sortDirection: data.rankingsData.defaultSelectedRanking.sortDirection,
    };
};
